import { baseArkhaleAPI } from './base-api'
import { ChangePasswordCurrentUser } from '../../shared/models/others/change-password'
import { ChangeSettings } from '../../shared/models/others/change-settings'
import { Pagination } from '../../shared/models/others/pagination'
import UserSession from '../../shared/models/user-session.model'

const meApi = baseArkhaleAPI.injectEndpoints({
  endpoints: (build) => ({
    updatePassword: build.mutation<
      { message: string },
      ChangePasswordCurrentUser
    >({
      query(data) {
        return {
          url: 'me/update-password',
          method: 'PATCH',
          body: data,
        }
      },
    }),
    updateInfos: build.mutation<
      string,
      { firstname: string; lastname: string; phone: string }
    >({
      query(data) {
        return { url: 'me', method: 'PUT', body: data }
      },
    }),
    updateSettings: build.mutation<ChangeSettings, ChangeSettings>({
      query(data) {
        return { url: 'me/update-settings', method: 'PATCH', body: data }
      },
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled
          await dispatch(
            baseArkhaleAPI.endpoints.me.initiate(null, {
              forceRefetch: true,
            })
          )
        } catch (error) {}
      },
    }),
    getSessions: build.query<Pagination<UserSession>, void>({
      query: () => ({ url: 'me/sessions' }),
    }),
    revokeSession: build.mutation<void, { sessionID: string }>({
      query({ sessionID }) {
        return {
          url: `me/sessions/${sessionID}`,
          method: 'DELETE',
        }
      },
    }),
  }),
})

export const {
  useUpdateInfosMutation,
  useUpdatePasswordMutation,
  useUpdateSettingsMutation,
  useGetSessionsQuery,
  useRevokeSessionMutation,
} = meApi
